import { h } from 'preact'
import Overview from '../overview'
import { userTag } from '../overview/filters/filters'
import EmptyPage from '../empty-page/EmptyPage'
import globals from '../../utils/globals'
import FormatCell from '../overview/cells/FormatCell'
import InviteStatusCell from '../overview/cells/InviteStatusCell'
import ButtonControl from '../button-control'

const ContactOverview = () => {
  function getFilters () {
    return [
      userTag()
    ]
  }

  function getColumns () {
    return [
      { header: 'Email address', accessor: 'email' },
      { header: 'Name', accessor: 'name' },
      { header: 'User tags', accessor: 'userTags', cell: FormatCell('userTags', (arr) => arr.join(',')) },
      { header: 'Invite status', accessor: 'invite', cell: InviteStatusCell() }
    ]
  }

  return <Overview
    type='contact'
    headerTitle='Contact Overview'
    headerButtons={[ <a href='/contact/import'>
      <ButtonControl title='Import contacts via csv'
        variant='brand'
        newStyle
        size='medium'
      />
    </a>]}
    withPagination={{
      page: 1,
      pageSize: 25
    }}
    withFilters={getFilters()}
    withSearch
    searchPlaceholder='Search contacts'
    rowId='id'
    model={getColumns()}
    endpoint='/contact/contacts'
    dataKey='contacts'
    EmptyStateComponent={<EmptyPage
      img_src={`${globals('defaultCdn')}/images/empty_page.png`}
      header='There are no contacts yet'
      text={'Seems like no one on your team has imported contacts. \n Start now by importing contacts.'}
      button={{ link: '/contacts/import', text: 'Import contacts' }}
    />}
  />
}

export default ContactOverview
